import { getUrlParameter } from '../../utils/get-url-param';
import i18next from 'i18next';

(function() {
  const sitename = getUrlParameter('site');
  const title = document.querySelector('.js-site-name');
  const tag = sitename ? 'SITE_USE_GRAVITEC' : 'TRY_GRAVITEC_NET';

  title.innerHTML = i18next.t(tag, { sitename });
  i18next.on('languageChanged', () => {
    title.innerHTML = i18next.t(tag, { sitename });
  });
})();